import { render, staticRenderFns } from "./OrgRolesCard.vue?vue&type=template&id=4a9952e5&scoped=true&"
import script from "./OrgRolesCard.vue?vue&type=script&lang=js&"
export * from "./OrgRolesCard.vue?vue&type=script&lang=js&"
import style0 from "./OrgRolesCard.vue?vue&type=style&index=0&id=4a9952e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9952e5",
  null
  
)

export default component.exports